export const getIdHeaderBannerSelect = (state) => state?.headerBanner?.id
